var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(21314 -11509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166",
    transform: "translate(-21440 11329)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(126 180)",
    fill: "#f2f3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2731",
    "data-name": "Ellipse 2731",
    transform: "translate(-21299.723 11554.75)",
    fill: "#c4c8eb",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 2.25,
    r: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2732",
    "data-name": "Ellipse 2732",
    transform: "translate(-21280.678 11554.75)",
    fill: "#c4c8eb",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 2.25,
    r: 2.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.25,
    cy: 2.25,
    r: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M-21369.631,11554.157h2.152a3.2,3.2,0,0,1,2.994-2.454,3.25,3.25,0,0,1,3.055,2.454h13.018s.631-2.5,3.012-2.465a3.663,3.663,0,0,1,3.193,2.465h4.486v-1.25h-1.205v-14.549h-19.814a2.33,2.33,0,0,0-1.041.313,1.57,1.57,0,0,0-.521.8v2.588h-5.488l-3.84,6.248Z",
    transform: "translate(67 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M-21356.822,11540.588v11.377",
    transform: "translate(67 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M-21356.822,11540.588v11.377",
    transform: "translate(72 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M-21356.822,11540.588v6.9",
    transform: "translate(76.322 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M-21356.822,11540.588v6.9",
    transform: "translate(80.645 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M-21367.777,11547.709h6.609v-4.248h-3.617Z",
    transform: "translate(67 2)",
    fill: "#c4c8eb",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M-21336.717,11554.269h.822v-25.612l-3.006-1.552v-11.8h-4.816v9.312l-2.887-1.489v14.979h7.869v14.611h1.2v1.55Z",
    transform: "translate(67 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4078",
    "data-name": "Rectangle 4078",
    transform: "translate(-21276 11531)",
    fill: "#c4c8eb",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M-21335.895,11554.269h10.564v-25.853l-1.65-.825v-12.249h-4.227v10.138l-4.687-2.343Z",
    transform: "translate(67 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4079",
    "data-name": "Rectangle 4079",
    transform: "translate(-21266 11531)",
    fill: "#c4c8eb",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4080",
    "data-name": "Rectangle 4080",
    transform: "translate(-21266 11543)",
    fill: "#c4c8eb",
    stroke: "#c4c8eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M-21370.359,11559.69h45.832",
    transform: "translate(67 2)",
    fill: "none",
    stroke: "#c4c8eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-21358.672 11455.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M68.376,74.652H66.426a.525.525,0,1,1,0-1.049h1.951a2.453,2.453,0,1,0,0-4.906c-.066,0-.136,0-.215.01a.525.525,0,0,1-.5-.26,3.434,3.434,0,0,0-6.356,1.14.525.525,0,0,1-.537.436h-.037a1.79,1.79,0,1,0,0,3.579h2.614a.525.525,0,0,1,0,1.049H60.732A2.84,2.84,0,0,1,60.363,69a4.484,4.484,0,0,1,8.034-1.35,3.5,3.5,0,1,1-.021,7.005Z",
    fill: "#c4c8eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M198.959,190.673a.523.523,0,0,1-.371-.154l-1.315-1.314-1.314,1.314a.525.525,0,0,1-.741-.742l1.685-1.685a.525.525,0,0,1,.742,0l1.685,1.685a.525.525,0,0,1-.371.9Z",
    transform: "translate(-132.387 -117.976)",
    fill: "#c4c8eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M243.265,194.753a.525.525,0,0,1-.525-.525v-5.763a.525.525,0,0,1,1.049,0v5.763A.525.525,0,0,1,243.265,194.753Z",
    transform: "translate(-178.379 -117.977)",
    fill: "#c4c8eb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.a0f522644c0d42f2b88afc3bc7a604b1.svg";
export { ForwardRef as ReactComponent };